import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@components/Button';
import { useBlockEditFormStore } from '@ContractBuilder/modules/block-edit';
import { UnsavedChangesModal } from '@ContractBuilder/modules/block-edit/views/UnsavedChangesModal';
import { useDatapointsStore } from '@ContractBuilder/store/datapoints.store';
import { LogoutIcon } from '@heroicons/react/outline';
import Nav from '@root/src/routes';

const EntraSaveCloseButton = () => {
  const isEditingBlock = useBlockEditFormStore(({ formValues }) => formValues?.id !== undefined);
  const { onSubmit, isDirty, onFormReset } = useDatapointsStore(({ onSubmit, isDirty, onFormReset }) => ({
    onSubmit,
    isDirty,
    onFormReset,
  }));
  const navigate = useNavigate();
  const [isUnsavedChangesModalOpen, setIsUnsavedChangesModalOpen] = useState(false);

  const continueSaveClose = async () => {
    await onSubmit();
    setIsUnsavedChangesModalOpen(false);
    navigate(Nav.Logout);
  };

  const handleSaveClose = async () => {
    if (isDirty) {
      setIsUnsavedChangesModalOpen(true);
      return;
    }
    await continueSaveClose();
  };

  return (
    <>
      <Button isDisabled={isEditingBlock} kind="secondary" className="h-[34px]" size="sm" onClick={handleSaveClose}>
        <LogoutIcon className="-mr-0.5 h-5 w-5" />
        Save &amp; Close
      </Button>
      <UnsavedChangesModal
        isOpen={isUnsavedChangesModalOpen}
        onCancel={() => setIsUnsavedChangesModalOpen(false)}
        onDisregardChanges={() => {
          onFormReset();
          setIsUnsavedChangesModalOpen(false);
          navigate(Nav.Logout);
        }}
        onSaveChanges={continueSaveClose}
      />
    </>
  );
};

export default EntraSaveCloseButton;
